module.exports = __webpack_public_path__ + "assets/55b45057eec9ce031614dbc8b4910309.mp4";